export default "__VITE_ASSET__CUVPQxhG__"